/**
 * Flights API — endpoint path builders (Package Suppliers backend).
 */

const API_BASE = process.env.RAZZLE_API_PACKAGE_PROVIDERS?.replace(/\/$/, '') ?? '';

export function airportSearchUrl(search: string): string {
  return `${API_BASE}/airport/search?search=${encodeURIComponent(search)}`;
}

export function airportSuggestionsUrl(kind = 'all'): string {
  return `${API_BASE}/airport/suggestions?kind=${encodeURIComponent(kind)}`;
}

export function airportByIdUrl(id: number): string {
  return `${API_BASE}/airport/${encodeURIComponent(String(id))}`;
}
